import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Aktivierungslink from './components/Aktivierungslink';
import Contact from './components/contact';
import Header from './components/Header';

function App() {
  return (
    <BrowserRouter>
    <Header />
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route path='/aktivierungslink/:id' element={<Aktivierungslink />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
